import * as React from 'react'
import './style.css'

export default function GuruIcon(props: any) {
  const {nameIcon} = props

  return (
    <div>
      <i aria-hidden='true' className={`icon icon-${nameIcon}`}></i>
    </div>
  )
}
